import { useState, useRef, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const CASES = [
  {
    id: 1,
    title: 'Uroczysko Polańczyk',
    subtitle: 'Luksusowy obiekt noclegowy w Polańczyku',
    url: 'uroczyskopolanczyk.com',
    category: 'Turystyka & Noclegi',
    result: '+210% rezerwacji online',
    tags: ['Strona Premium', 'Agent AI', 'Local SEO'],
    color: '#00d4ff',
    accent: 'rgba(0,212,255,0.18)',
    bg: 'linear-gradient(135deg, #0a1628 0%, #061520 40%, #081e2a 100%)',
    num: '01',
  },
  {
    id: 2,
    title: 'Rajskie Uroczysko',
    subtitle: 'Apartamenty premium – Bieszczady',
    url: 'rajskieuroczysko.pl',
    category: 'Turystyka & Noclegi',
    result: 'Top 3 Google · +180% zapytań',
    tags: ['Strona Premium', 'Agent AI', 'SEO'],
    color: '#00ff88',
    accent: 'rgba(0,255,136,0.15)',
    bg: 'linear-gradient(135deg, #071a10 0%, #041208 40%, #081c12 100%)',
    num: '02',
  },
  {
    id: 3,
    title: 'FallHouse',
    subtitle: 'Luksusowe apartamenty premium',
    url: 'fallhouse.pl',
    category: 'Turystyka & Noclegi',
    result: 'Automatyzacja AI + SEO regionalne',
    tags: ['Strona Premium', 'Automatyzacja AI', 'SEO'],
    color: '#ff6b9d',
    accent: 'rgba(255,107,157,0.15)',
    bg: 'linear-gradient(135deg, #1a0810 0%, #120509 40%, #1c0a12 100%)',
    num: '03',
  },
  {
    id: 4,
    title: 'Biesy i Czady',
    subtitle: 'Restauracja & Pizzeria Bieszczady',
    url: 'pizzeria-polanczyk.pl',
    category: 'Gastronomia',
    result: 'Menu online + Agent na zamówienia',
    tags: ['Strona', 'Menu Online', 'Agent AI'],
    color: '#ffb347',
    accent: 'rgba(255,179,71,0.15)',
    bg: 'linear-gradient(135deg, #1a1200 0%, #120d00 40%, #1c1400 100%)',
    num: '04',
  },
  {
    id: 5,
    title: 'Gazdówka Cisna',
    subtitle: 'Dom wypoczynkowy w Cisnej',
    url: 'gazdowkacisna.pl',
    category: 'Turystyka & Noclegi',
    result: '+300% widoczność na mapach Google',
    tags: ['Strona', 'Google Wizytówka', 'Local SEO'],
    color: '#00ff88',
    accent: 'rgba(0,255,136,0.15)',
    bg: 'linear-gradient(135deg, #071a10 0%, #041208 40%, #061a0e 100%)',
    num: '05',
  },
  {
    id: 6,
    title: 'Dębowa Gazdówka',
    subtitle: 'Obiekt noclegowy w Bieszczadach',
    url: 'debowagazdowka.eu',
    category: 'Turystyka & Noclegi',
    result: 'Rebrand + dominacja w Local SEO',
    tags: ['Rebrand Cyfrowy', 'Strona', 'SEO'],
    color: '#c9a96e',
    accent: 'rgba(201,169,110,0.15)',
    bg: 'linear-gradient(135deg, #141008 0%, #0e0b05 40%, #161208 100%)',
    num: '06',
  },
  {
    id: 7,
    title: 'FALLWOOD – Bębny',
    subtitle: 'Producent bębnów kablowych',
    url: 'fallwood.pl',
    category: 'Przemysł & B2B',
    result: 'Strona B2B + generowanie leadów',
    tags: ['Strona B2B', 'Lead Generation', 'SEO'],
    color: '#00d4ff',
    accent: 'rgba(0,212,255,0.15)',
    bg: 'linear-gradient(135deg, #0a1628 0%, #061520 40%, #081e2a 100%)',
    num: '07',
  },
  {
    id: 8,
    title: 'FALLWOOD – Pellet',
    subtitle: 'Producent ekologicznego pelletu',
    url: 'fallwood.pl',
    category: 'Przemysł & B2B',
    result: 'E-commerce B2B + dystrybucja online',
    tags: ['Strona B2B', 'E-commerce', 'SEO'],
    color: '#7ddc1f',
    accent: 'rgba(125,220,31,0.15)',
    bg: 'linear-gradient(135deg, #0c1a04 0%, #080e02 40%, #0e1a04 100%)',
    num: '08',
  },
  {
    id: 9,
    title: 'NUTRIFAL',
    subtitle: 'Studio Dietetyki',
    url: 'nutrifal.pl',
    category: 'Zdrowie & Beauty',
    result: '+65% konwersji na rejestracje',
    tags: ['Strona Premium', 'Agent AI', 'SEO'],
    color: '#ff6b9d',
    accent: 'rgba(255,107,157,0.15)',
    bg: 'linear-gradient(135deg, #1a0810 0%, #120509 40%, #1c0a12 100%)',
    num: '09',
  },
  {
    id: 10,
    title: 'Solińska Restauracja',
    subtitle: 'Pokusa Smaków – Jezioro Solińskie',
    url: 'solinskarestauracja.pl',
    category: 'Gastronomia',
    result: '+140% rezerwacji z Google Maps',
    tags: ['Strona', 'System Rezerwacji', 'Local SEO'],
    color: '#00d4ff',
    accent: 'rgba(0,212,255,0.15)',
    bg: 'linear-gradient(135deg, #0a1628 0%, #061520 40%, #0a1e2c 100%)',
    num: '10',
  },
  {
    id: 11,
    title: 'Santa Barbara',
    subtitle: 'Restauracja nad Jeziorem Solińskim',
    url: 'santabarbara-solina.pl',
    category: 'Gastronomia',
    result: 'Premium brand + wzrost reputacji',
    tags: ['Strona Premium', 'Branding', 'SEO'],
    color: '#e8c97e',
    accent: 'rgba(232,201,126,0.15)',
    bg: 'linear-gradient(135deg, #191208 0%, #110c04 40%, #1a1206 100%)',
    num: '11',
  },
  {
    id: 12,
    title: 'Restauracja Kamionka',
    subtitle: 'Smaki Bieszczad',
    url: 'restauracja-kamionka.pl',
    category: 'Gastronomia',
    result: 'Widoczność lokalna + menu online',
    tags: ['Strona', 'Menu Online', 'Local SEO'],
    color: '#ff6b9d',
    accent: 'rgba(255,107,157,0.15)',
    bg: 'linear-gradient(135deg, #1a0810 0%, #120509 40%, #1c0a12 100%)',
    num: '12',
  },
  {
    id: 13,
    title: 'Eureka – Stal',
    subtitle: 'Konstrukcje stalowe dla przemysłu',
    url: 'eureka-stal.pl',
    category: 'Przemysł & B2B',
    result: 'Strona B2B + generowanie zapytań',
    tags: ['Strona Przemysłowa', 'B2B', 'Lead Gen'],
    color: '#94a3b8',
    accent: 'rgba(148,163,184,0.15)',
    bg: 'linear-gradient(135deg, #0e1116 0%, #080b0f 40%, #10141a 100%)',
    num: '13',
  },
];

export default function CasesSlider() {
  const [active, setActive] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const autoRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const touchStartX = useRef<number | null>(null);
  const touchStartY = useRef<number | null>(null);
  const thumbsRef = useRef<HTMLDivElement>(null);

  const stopAuto = useCallback(() => {
    if (autoRef.current) clearInterval(autoRef.current);
  }, []);

  const startAuto = useCallback(() => {
    stopAuto();
    autoRef.current = setInterval(() => {
      setActive((a) => (a + 1) % CASES.length);
    }, 4500);
  }, [stopAuto]);

  useEffect(() => {
    startAuto();
    return stopAuto;
  }, [startAuto, stopAuto]);

  const goTo = useCallback((i: number) => {
    if (isAnimating) return;
    setIsAnimating(true);
    setActive(i);
    setTimeout(() => setIsAnimating(false), 600);
    startAuto();
    if (thumbsRef.current) {
      const btn = thumbsRef.current.children[i] as HTMLElement;
      if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }, [isAnimating, startAuto]);

  const goPrev = useCallback(() => goTo((active - 1 + CASES.length) % CASES.length), [active, goTo]);
  const goNext = useCallback(() => goTo((active + 1) % CASES.length), [active, goTo]);

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null || touchStartY.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    const dy = e.changedTouches[0].clientY - touchStartY.current;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 45) {
      if (dx < 0) goNext();
      else goPrev();
    }
    touchStartX.current = null;
    touchStartY.current = null;
  };

  const cur = CASES[active];

  return (
    <section className="py-20 md:py-28 bg-[#080808] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

      <div className="max-w-[1400px] mx-auto px-4 md:px-6">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-5">
          <div>
            <p className="text-[#00d4ff] text-xs uppercase tracking-[3px] font-semibold mb-3">Nasze realizacje</p>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
              Realne projekty,<br />
              <span className="text-white/35">mierzalne wyniki</span>
            </h2>
          </div>
          <div className="flex items-center gap-5 flex-shrink-0">
            <span className="text-white/30 text-sm hidden md:block font-mono">
              {String(active + 1).padStart(2, '0')} / {String(CASES.length).padStart(2, '0')}
            </span>
          </div>
        </div>

        {/* Main slide area */}
        <div
          className="relative rounded-3xl overflow-hidden select-none touch-pan-y border border-white/[0.06]"
          style={{ height: 'clamp(340px, 48vw, 560px)' }}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          {/* Gradient slides */}
          {CASES.map((c, i) => (
            <div
              key={c.id}
              className="absolute inset-0 flex items-center"
              style={{
                background: c.bg,
                opacity: i === active ? 1 : 0,
                transition: 'opacity 0.65s cubic-bezier(0.4,0,0.2,1)',
                pointerEvents: i === active ? 'auto' : 'none',
                zIndex: i === active ? 1 : 0,
              }}
            >
              {/* Ambient glow */}
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background: `radial-gradient(ellipse at 70% 50%, ${c.accent} 0%, transparent 65%)`,
                }}
              />
              {/* Big number bg decoration */}
              <div
                className="absolute right-8 md:right-16 top-1/2 -translate-y-1/2 font-black select-none pointer-events-none leading-none"
                style={{
                  fontSize: 'clamp(120px, 18vw, 240px)',
                  color: c.color,
                  opacity: 0.06,
                  letterSpacing: '-0.05em',
                }}
              >
                {c.num}
              </div>
              {/* Horizontal divider line decoration */}
              <div
                className="absolute left-0 right-0 h-px top-1/2 -translate-y-1/2 pointer-events-none"
                style={{ background: `linear-gradient(to right, transparent, ${c.color}20 30%, ${c.color}08 70%, transparent)` }}
              />
            </div>
          ))}

          {/* Content overlay */}
          <div className="absolute inset-0 z-10 flex items-center px-8 md:px-14 lg:px-20">
            <div className="max-w-[640px]">
              {/* Category */}
              <div
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[10px] md:text-[11px] font-bold uppercase tracking-wider mb-5"
                style={{
                  background: `${cur.color}15`,
                  border: `1px solid ${cur.color}35`,
                  color: cur.color,
                  transition: 'all 0.4s ease',
                }}
              >
                <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: cur.color }} />
                {cur.category}
              </div>

              {/* Title */}
              <h3
                className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-2 leading-tight"
                style={{ transition: 'all 0.4s ease' }}
              >
                {cur.title}
              </h3>
              <p className="text-white/45 text-sm md:text-base mb-6 font-medium leading-snug">{cur.subtitle}</p>

              {/* Result metric */}
              <div
                className="inline-flex items-center gap-2.5 px-4 py-2.5 rounded-xl mb-6"
                style={{
                  background: `${cur.color}12`,
                  border: `1px solid ${cur.color}30`,
                  transition: 'all 0.4s ease',
                }}
              >
                <i className="ri-bar-chart-box-fill text-base" style={{ color: cur.color }} />
                <span className="font-bold text-sm md:text-base" style={{ color: cur.color }}>{cur.result}</span>
              </div>

              {/* Tags */}
              <div className="hidden sm:flex flex-wrap gap-2">
                {cur.tags.map((t) => (
                  <span
                    key={t}
                    className="px-3 py-1.5 rounded-full text-[10px] md:text-xs font-semibold"
                    style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', color: 'rgba(255,255,255,0.55)' }}
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* URL chip — bottom right */}
          <div className="absolute bottom-5 right-5 z-20 flex items-center gap-1.5 px-3 py-1.5 rounded-lg"
            style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.09)' }}>
            <i className="ri-lock-2-line text-[10px]" style={{ color: cur.color }} />
            <span className="font-mono text-[10px] text-white/35">{cur.url}</span>
          </div>

          {/* Arrow buttons */}
          <button
            onClick={goPrev}
            className="absolute left-3 md:left-5 top-1/2 -translate-y-1/2 z-20 w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full border border-white/15 bg-black/40 backdrop-blur-md hover:bg-white/10 hover:border-white/35 transition-all duration-200 cursor-pointer"
            aria-label="Poprzedni"
          >
            <i className="ri-arrow-left-s-line text-white text-xl" />
          </button>
          <button
            onClick={goNext}
            className="absolute right-3 md:right-5 top-1/2 -translate-y-1/2 z-20 w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full border border-white/15 bg-black/40 backdrop-blur-md hover:bg-white/10 hover:border-white/35 transition-all duration-200 cursor-pointer"
            aria-label="Następny"
          >
            <i className="ri-arrow-right-s-line text-white text-xl" />
          </button>
        </div>

        {/* Thumbnails strip — text-only, no images */}
        <div
          ref={thumbsRef}
          className="flex gap-2 mt-3 overflow-x-auto pb-1"
          style={{ scrollSnapType: 'x mandatory', msOverflowStyle: 'none', scrollbarWidth: 'none' }}
        >
          {CASES.map((c, i) => (
            <button
              key={c.id}
              onClick={() => goTo(i)}
              className="flex-shrink-0 relative rounded-xl overflow-hidden cursor-pointer transition-all duration-300 px-3 py-2 flex flex-col items-start justify-center"
              style={{
                minWidth: '90px',
                height: '52px',
                scrollSnapAlign: 'start',
                background: i === active ? `${c.color}18` : 'rgba(255,255,255,0.04)',
                border: `1.5px solid ${i === active ? c.color + '60' : 'rgba(255,255,255,0.08)'}`,
                opacity: i === active ? 1 : 0.5,
              }}
            >
              <span
                className="text-[8px] font-black font-mono leading-none mb-0.5"
                style={{ color: i === active ? c.color : 'rgba(255,255,255,0.35)' }}
              >
                {c.num}
              </span>
              <span
                className="text-[8px] font-semibold leading-tight text-left w-full truncate"
                style={{ color: i === active ? 'rgba(255,255,255,0.85)' : 'rgba(255,255,255,0.35)' }}
              >
                {c.title}
              </span>
            </button>
          ))}
        </div>

        {/* Dot progress */}
        <div className="flex items-center justify-center gap-1.5 mt-4">
          {CASES.map((c, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className="cursor-pointer rounded-full transition-all duration-350"
              style={{
                width: i === active ? '22px' : '5px',
                height: '5px',
                background: i === active ? c.color : 'rgba(255,255,255,0.15)',
              }}
            />
          ))}
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center mt-12 gap-3">
          <p className="text-white/30 text-sm tracking-wide">13 ukończonych wdrożeń · Różne branże i skala</p>
          <Link
            to="/realizacje"
            className="inline-flex items-center gap-2.5 px-9 py-4 rounded-2xl font-bold text-sm text-black whitespace-nowrap cursor-pointer transition-all duration-200 hover:scale-105"
            style={{ background: 'linear-gradient(135deg, #00d4ff 0%, #00ff88 100%)' }}
          >
            <i className="ri-gallery-line text-base" />
            Zobacz wszystkie realizacje
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </div>
      </div>

      <style>{`div::-webkit-scrollbar { display: none; }`}</style>
    </section>
  );
}
